// src/services/advance.js
import { api } from "./api";

export async function fetchAdvanceList(mainuser) {
  if (!mainuser) throw new Error("mainuser missing");

  const res = await api.get("getuchalyenelistmd.php", {
    params: { mainuser },
    responseType: "text",
    transformResponse: (r) => r,
  });

  return res.data; // string
}

export async function saveAdvanceTx(payload) {
  // payload fields:
  // mainuser, mobileuser, date, kno, type, amt, intr, remark, sredit, flag
  const body = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => body.append(k, String(v ?? "")));

  const res = await api.post("saveuchalmd.php", body.toString(), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "text",
    transformResponse: (r) => r,
  });

  return res.data; // server returns string: "Saved." / "updated." etc
}
